module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ipadfp"
  }, [_c('img', {
    staticClass: "imagefp",
    attrs: {
      "alt": "Cover: The Unofficial Hogwarts Cocktail Book, by Barmann",
      "aria-describedby": "cover-alt",
      "role": "doc-cover",
      "src": "e9781646043705/images/9781646043705.jpg"
    }
  })]), _vm._v(" "), _c('aside', {
    attrs: {
      "hidden": "hidden",
      "id": "cover-alt"
    }
  }, [_c('p', [_vm._v("Spellbinding Spritzes, Fantastical Old Fashioneds, Magical Margaritas, and More Enchanting Recipes")]), _vm._v(" "), _c('p', [_vm._v("The Unofficial Hogwarts Cocktail Book")]), _vm._v(" "), _c('p', [_vm._v("Bertha Barmann")]), _vm._v(" "), _c('p', [_vm._v("This book is not associated with or authorized or approved by J. K. Rowling, her publishers, or Warner Bros.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7978760c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646043705/xhtml/cover.vue
// module id = 54
// module chunks = 0